import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApilistService } from '../../../../service/Api/apilist.service';
import { GlobalService } from '../../../global.service';
declare const $;

@Component({
  selector: 'app-add-subscription',
  templateUrl: './add-subscription.component.html',
  styleUrls: ['./add-subscription.component.css']
})
export class AddSubscriptionComponent implements OnInit {

  IdMerchant = parseInt(sessionStorage.getItem('referMerchantId'), 0);
  companyName = sessionStorage.getItem('companyName');
  AlertText: string;

  constructor(
    private router: Router,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private globalservice: GlobalService,
    public apiList: ApilistService, private cd: ChangeDetectorRef) { }

  Update;
  edit_Id;
  edit_details;
  UserList: any[];
  AlertTypeArray = ['Daily', 'Live', 'Both'];
  AlertType;
  EventTypeId;
  EventSection: boolean = false;
  IdUser;
  EventTypeArray: any[] = [];
  SubscriptionsData: any[];
  DailySlider = {
    IsAlertEnabled: false,
    IsAlertStatus: 0
  };

  LiveSlider = {
    IsAlertEnabled: false,
    IsAlertStatus: 0
  };


  ScreenOrientation; SpecificationName; ScreenResolution; ScreenSize; ScreenOrientationorg; SpecificationNameorg; ScreenResolutionorg; ScreenSizeorg;

  ngOnInit() {
    $('#dots_spinner').hide();
    $('#alert_div').hide();
    if (this.IdUser == undefined || this.IdUser == null) {
      this.EventSection = false;
    }
    else {
      this.EventSection = true;
    }
    //console.log("companyname" + this.companyName);
    this.getUsers();
    // this.GetAlertsTypes();

  }
  getUsers() {
    $('#dots_spinner').show();
    this.http.get<any>(this.apiList.GetChildMerchants, this.globalservice.Headers())
      .timeout(25000)
      .take(1)
      .map(resp => {
        if (resp == null) { resp = { Response: 0, ErrorMessage: 'Blank response' }; }
        if (+resp.Response !== 1) { throw resp; }
        return resp;
      }).subscribe((response) => {
        this.UserList = response.Merchants;
        // this.EventTypeArray = response.EventTypes;

      }, (err: any) => {
        const Error = this.globalservice.ProcessError(err);
        if (Error.Response === 35) {
          if (Error.ErrorMessage) {
            this.FlashError(Error.ErrorMessage);
            this.globalservice.Logout('Yes');
          }
          this.globalservice.Logout('No');
          return;
        } else {
          this.FlashError(Error.ErrorMessage);
          return;
        }
      }).add(() => { $('#dots_spinner').hide(); });
  }
  checkSliderDaily(value) {
    this.DailySlider.IsAlertEnabled = value.checked;
    if (value.checked == true) {
      this.DailySlider.IsAlertStatus = 1;
    }
    else {
      this.DailySlider.IsAlertStatus = 0;
    }
  }

  checkSliderLive(value) {
    this.LiveSlider.IsAlertEnabled = value.checked;
    if (value.checked == true) {
      this.LiveSlider.IsAlertStatus = 1;
    }
    else {
      this.LiveSlider.IsAlertStatus = 0;
    }
  }

  GetEventList(iduser) {
    this.EventTypeArray = [];
    $('#dots_spinner').show();
    this.http.post<any>(this.apiList.GetSingleSubscribedAlertList, { IdMerchant: iduser }, this.globalservice.Headers())
      .timeout(25000)
      .take(1)
      .map(resp => {
        if (resp == null) { resp = { Response: 0, ErrorMessage: 'Blank response' }; }
        if (+resp.Response !== 1) { throw resp; }
        return resp;
      }).subscribe((response) => {
        this.EventTypeArray = response.merchantSubscribes.Subscriptions;
        //  this.cd.detectChanges();

      }, (err: any) => {
        const Error = this.globalservice.ProcessError(err);
        if (Error.Response === 35) {
          if (Error.ErrorMessage) {
            this.FlashError(Error.ErrorMessage);
            this.globalservice.Logout('Yes');
          }
          this.globalservice.Logout('No');
          return;
        } else {
          this.FlashError(Error.ErrorMessage);
          return;
        }
      }).add(() => { $('#dots_spinner').hide(); });
  }



  SaveAs() {
    $('#dots_spinner').show();
    this.http.post<any>(this.apiList.SubscribeAlerts,
      {
        IdMerchant: this.IdUser,
        Subscriptions: this.EventTypeArray


      }, this.globalservice.Headers())
      .timeout(25000)
      .take(1)
      .map(resp => {
        if (resp == null) { resp = { Response: 0, ErrorMessage: 'Blank response' }; }
        if (+resp.Response !== 1) { throw resp; }
        return resp;
      }).subscribe((response) => {
        if (response.Response === 1) {
          this.Update = response;
          this.FlashSuccess('Successfully Added');
        }
      }, (err: any) => {
        const Error = this.globalservice.ProcessError(err);
        if (Error.Response === 35) {
          if (Error.ErrorMessage) {
            this.FlashError(Error.ErrorMessage);
            this.globalservice.Logout('Yes');
          }
          this.globalservice.Logout('No');
          return;
        } else {
          this.FlashError(Error.ErrorMessage);
          return;
        }
      }).add(() => { $('#dots_spinner').hide(); });
  }
  FlashError(message: string) {
    this.AlertText = '';
    this.AlertText = message;
    this.EventSection = false;
    $('#alert_div').show();
    $('#alert_div').animate({
      width: '100%'
    }, 'slow');
    setTimeout(() => {
      $('#alert_div').hide();
    }, 3000);
  }


  FlashSuccess(message: string) {
    this.AlertText = '';
    this.AlertText = message;
    $('#alert_div').show();
    $('#alert_div').animate({
      width: '100%'
    }, 'slow');
    setTimeout(() => {
      $('#alert_div').hide();
      this.router.navigate([this.companyName + '/dashboard/eventsubscription']);
    }, 3000);
  }

  changeAlert(val) {
    this.AlertType = val;
  }
  changeUser(val) {
    this.IdUser = val;
    if (this.IdUser == undefined || this.IdUser == null) {
      this.EventSection = false;
    }
    else {
      this.EventSection = true;
      this.GetEventList(this.IdUser);
    }
  }

  //
  onDailyStatusChanged(event, eventid) {
    var indexEvent = this.EventTypeArray.filter(ij => ij.EventTypeId == eventid)[0];
    if (indexEvent !== undefined) {
      var index22 = this.EventTypeArray.indexOf(indexEvent);
      this.EventTypeArray[index22].IsDaily = event.checked;
    }
  }

  onLiveStatusChanged(event, eventid) {
    var indexEvent = this.EventTypeArray.filter(ij => ij.EventTypeId == eventid)[0];
    if (indexEvent !== undefined) {
      var index22 = this.EventTypeArray.indexOf(indexEvent);
      this.EventTypeArray[index22].IsLive = event.checked;
    }

  }

  sortData(event) { //$$ BUG: Stub added for compile. Html refers, but no implementation.

  }

  goback() {
    this.router.navigate([this.companyName + '/dashboard/eventsubscription']);
  }

}
